import {Injectable} from '@angular/core';

@Injectable()
export class FormService {

  constructor() {}

  clearErrors(form) {
      Object.keys(form.controls).map((key) => {
        if (form.controls[key].errors) {
          form.controls[key].markAsUntouched();
         // form.controls[key].setErrors({'rangeError': false});
        }
      });
  }

  setTouched(form) {
    Object.keys(form.controls).map((key) => {
      form.controls[key].markAsTouched();
    });
  }

  setUntouched(form) {
    Object.keys(form.controls).map((key) => {
      form.controls[key].markAsUntouched();
    });
  }

  setFocus(className: string) {
    const inputs = document.querySelectorAll(`.${className} input`);
    const inputsCopy = [];
    let el: any;
    setTimeout(() => {
      for (let i = 0; i < inputs.length; i++ ) {
        inputsCopy.push(inputs[i]);
      }
      el = inputsCopy.find((item) => {
        return item.classList.contains('ng-invalid');
      });
      if (!el) return;
      el.focus();
    });
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/service/FormService.ts